import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import BenchLink from 'link-preview/BenchLink';
import {PreparedSample} from 'workflows/samples/PreparedSampleGroupConstants';
import {STAGE_RUN_SAMPLE_FULL_SHAPE, StageRunSample} from 'workflows/WorkflowConstants';

function StageRunSampleLink({sample}: StageRunSampleLinkProps): JSX.Element {
  if (sample == null) {
    return <span className="u-faded u-italic">Loading</span>;
  }
  if (sample.url) {
    return (
      <BenchLink href={benchlingUtil.pathToURL(sample.url)}>
        {(sample as StageRunSample).bioentity?.displayLabel ?? sample.name}
      </BenchLink>
    );
  } else {
    return <span>{(sample as StageRunSample).bioentity?.displayLabel ?? sample.name}</span>;
  }
}

interface StageRunSampleLinkProps {
  sample: StageRunSample | PreparedSample | null;
}

StageRunSampleLink.propTypes = {
  sample: STAGE_RUN_SAMPLE_FULL_SHAPE,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default StageRunSampleLink;
